import React from "react";
import SafeIcon from "../../../common/SafeIcon";
import { FiCalendar, FiRotateCcw, FiSearch } from "react-icons/fi";

export default function ClientInvoiceFilters({
  search,
  status,
  startDate,
  endDate,
  sortBy,
  onChange,
  onReset,
}) {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-[minmax(220px,1fr)_170px_160px_160px_170px_auto] xl:items-end">
        <label className="block">
          <span className="mb-1.5 block text-xs font-semibold text-slate-600">
            Search invoices
          </span>
          <span className="flex items-center gap-2 rounded-xl border border-slate-200 px-3 py-2.5 focus-within:border-violet-400 focus-within:ring-4 focus-within:ring-violet-500/10">
            <SafeIcon icon={FiSearch} className="text-slate-400" />
            <input
              value={search}
              onChange={(event) => onChange("search", event.target.value)}
              placeholder="Invoice number or customer"
              className="min-w-0 flex-1 bg-transparent text-sm text-slate-800 outline-none placeholder:text-slate-400"
            />
          </span>
        </label>

        <label className="block">
          <span className="mb-1.5 block text-xs font-semibold text-slate-600">
            Status
          </span>
          <select
            value={status}
            onChange={(event) => onChange("status", event.target.value)}
            className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-700 outline-none focus:border-violet-400 focus:ring-4 focus:ring-violet-500/10"
          >
            <option value="all">All statuses</option>
            <option value="draft">Draft</option>
            <option value="sent">Sent / Open</option>
            <option value="viewed">Viewed</option>
            <option value="partial">Partially paid</option>
            <option value="overdue">Overdue</option>
            <option value="paid">Paid</option>
            <option value="refunded">Refunded</option>
            <option value="void">Void / Canceled</option>
          </select>
        </label>

        <label className="block">
          <span className="mb-1.5 block text-xs font-semibold text-slate-600">
            Issue date from
          </span>
          <span className="flex items-center gap-2 rounded-xl border border-slate-200 px-3 py-2">
            <SafeIcon icon={FiCalendar} className="shrink-0 text-slate-400" />
            <input
              type="date"
              value={startDate}
              onChange={(event) => onChange("startDate", event.target.value)}
              className="w-full min-w-0 bg-transparent text-sm text-slate-700 outline-none"
            />
          </span>
        </label>

        <label className="block">
          <span className="mb-1.5 block text-xs font-semibold text-slate-600">
            Issue date to
          </span>
          <span className="flex items-center gap-2 rounded-xl border border-slate-200 px-3 py-2">
            <SafeIcon icon={FiCalendar} className="shrink-0 text-slate-400" />
            <input
              type="date"
              value={endDate}
              onChange={(event) => onChange("endDate", event.target.value)}
              className="w-full min-w-0 bg-transparent text-sm text-slate-700 outline-none"
            />
          </span>
        </label>

        <label className="block">
          <span className="mb-1.5 block text-xs font-semibold text-slate-600">
            Sort by
          </span>
          <select
            value={sortBy}
            onChange={(event) => onChange("sortBy", event.target.value)}
            className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-700 outline-none focus:border-violet-400 focus:ring-4 focus:ring-violet-500/10"
          >
            <option value="newest">Newest first</option>
            <option value="oldest">Oldest first</option>
            <option value="due">Due date</option>
            <option value="amount">Amount</option>
          </select>
        </label>

        <button
          type="button"
          onClick={onReset}
          className="inline-flex h-[42px] items-center justify-center gap-2 rounded-xl border border-slate-200 px-3 text-xs font-semibold text-slate-600 transition hover:bg-slate-50"
        >
          <SafeIcon icon={FiRotateCcw} />
          Reset
        </button>
      </div>

      {startDate && endDate && startDate > endDate && (
        <p role="alert" className="mt-3 text-xs font-medium text-rose-700">
          The start date must be on or before the end date.
        </p>
      )}
    </section>
  );
}